import { Modal, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const PrivacyPolicy = ({ open, setShowPolicy }) => {
  return (
    <Modal
      title={
        <div>
          <Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            Privacy Policy
          </Title>
        </div>
      }
      open={open}
      onCancel={() => setShowPolicy(false)}
      bodyStyle={{ padding: 0 }}
      width={600}
      footer={false}
    >
      <div className='terms-condition-body'>
        <Paragraph>
          Thank you for choosing Mike DocCompare (“Service”). We firmly believe that your business
          is no one else’s. Your privacy is important to us and so we will protect all the
          information you share with us.
        </Paragraph>
        <Paragraph>
          We will ask you when we need information that personally identifies you (Personal
          Information) or allows us to contact you. Generally, this information is requested when
          you register on the site or purchase our Services. We use your Personal Information for
          the following primary purposes –
        </Paragraph>
        <Paragraph>1. Providing personalized offers;</Paragraph>
        <Paragraph>2. Analyzing data for market research;</Paragraph>
        <Paragraph>3. Sending you exclusive offers and promotional materials;</Paragraph>
        <Paragraph>
          We may also collect device-specific information including but not limited to hardware
          model, operating system version and mobile network information. When you use our Services
          or view content on our website, we may automatically collect and store certain information
          in server logs. This may include –
        </Paragraph>
        <Paragraph>1. Details of how you used our service;</Paragraph>
        <Paragraph>2. Internet protocol address;</Paragraph>
        <Paragraph>
          3. Device event information including but not limited to crashes, system activity, browser
          type, hardware settings and referral URL;
        </Paragraph>
        <Paragraph>
          4. Cookies that may uniquely identify your browser or your Mike DocCompare account.
        </Paragraph>
        <Paragraph>
          The security of your Personal Information is very important to us and we ensure that we
          follow the safest and best possible method for transmission of data and storage of data.
          However, we shall not be liable in the event of any breach of data.
        </Paragraph>
      </div>
    </Modal>
  );
};

export default PrivacyPolicy;
